import { WarningBox } from "@components/cards/messageBox";
import React from "react";
import { WarningAdditionalMessages } from "./warningMessages";

export interface WarningObject {
    code: number;
    message: string | JSX.Element;
}

interface WarningsProps {
    errors: WarningObject[];
    filterCodes?: number[];
    additionalMessages?: WarningAdditionalMessages;
}

const paragraphStyle = {
    marginTop: '1.5vh',
};

const Warnings: React.FC<WarningsProps> = ({ errors, filterCodes, additionalMessages }) => {
    const warnings = filterCodes
        ? errors.filter(err => filterCodes.includes(err.code))
        : errors;

    if (warnings.length === 0) return null;

    return (
        <div>
            {warnings.map((err, index) => (
                <div key={index}>
                    <WarningBox message={err.message} />
                    {additionalMessages?.[err.code] && (
                        <p style={paragraphStyle}>
                            {additionalMessages[err.code]}
                        </p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Warnings;
